import { render, staticRenderFns } from "./OrganizationInfo.vue?vue&type=template&id=9e2723e6"
import script from "./OrganizationInfo.vue?vue&type=script&lang=js"
export * from "./OrganizationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports